import filter from 'lodash/filter';
import sortBy from 'lodash/sortBy';
import { createSelector } from 'reselect';
import { RootState } from 'store/types';
import { EducationItem, PatientEducationListState } from './types';

export const patientEducationListSelector = (state: RootState): PatientEducationListState =>
  state.patientEducation.list;

export const patientEducationListDataSelector = createSelector(
  patientEducationListSelector,
  list => list.data
);

export const patientEducationListFetchingSelector = createSelector(
  patientEducationListSelector,
  list => list.isFetching
);

export const patientEducationListErrorSelector = createSelector(
  patientEducationListSelector,
  list => list.error
);

export const patientEducationRequestStateSelector = createSelector(
  patientEducationListSelector,
  list => list.requestState
);

export const patientEducationLastUpdatedSelector = createSelector(
  patientEducationListSelector,
  list => list.lastUpdated
);

export const patientEducationIncompleteDataSelector = createSelector(
  patientEducationListDataSelector,
  data =>
    sortBy(
      filter(data, (item: EducationItem) => item?.status !== 'Completed'),
      ['viewBy']
    )
);

export const patientEducationCompleteDataSelector = createSelector(
  patientEducationListDataSelector,
  data => data?.filter((item: EducationItem) => item?.status === 'Completed')
);

export const patientEducationDataCountSelector = createSelector(
  [
    patientEducationListDataSelector,
    patientEducationCompleteDataSelector,
    patientEducationIncompleteDataSelector
  ],
  (totalCount, completeCount, incompleteCount) => ({
    totalCount: totalCount?.length || 0,
    completeCount: completeCount?.length || 0,
    incompleteCount: incompleteCount?.length || 0
  })
);
